import template from './navbar.html';
import controller from './navbar.controller';
import './navbar.styl';

const navbarComponent = {
    template,
    controller,
    controllerAs: 'navbar',
    require: {
        app: '^^app'
    }
};

export default navbarComponent;


/** WEBPACK FOOTER **
 ** ./frontend/components/navbar/navabar.component.js
 **/